<script>
	import {game, user, view} from "../client.svelte.js";
	import Collapsible from "./Collapsible.svelte";

	let { Card, grpdEntries, groups, onselect } = $props();
	// $inspect(`CATALOG for ${view.layout.page}: `, Card, grpdEntries, onselect)
</script>


<!-------------------------------- HTML -------------------------------------->
	{#each Object.entries(grpdEntries) as [group, entries]}
		<Collapsible header={group} expanded={entries.length > 0}>
			<div class=groupBox>
				{#each entries as entry}
					<Card data={entry} {onselect}/>
				{/each}
			</div>
		</Collapsible>
	{/each}


<!------------------------------- STYLE ------------------------------------->
<style lang="sass">
	.overview
    height: 100%
    overflow: auto
    scrollbar-width: none

	.groupBox
    display: flex
    flex-wrap: wrap

</style>